export class FilterModel {
    entity_code: number;
    year: number;
    version: number;
    type_id: number;
    employee_code: number;
    itemCode: string;
  }
  